export const MOBILE_VIEW_THRESHOLD = 991;
